<div class="flex justify-between items-center py-4">
  <h2 class="text-lg font-semibold text-indigo-900">
    {{ 'ONB_CORPORATE.CORPORATE_INFORMATION' | translate }}
    <span *ngIf="isViewMode" class="ms-2 text-sm font-normal text-gray-500">
      ({{ 'ONBOARDING.VIEW_MODE' | translate }})
    </span>
  </h2>
  <app-back-button></app-back-button>
</div>

<section class="bg-white rounded-xl p-6 space-y-6">
  <app-dynamic-form [fields]="fields" (formSubmit)="onFormSubmit($event)">
  </app-dynamic-form>

  <!-- Edit mode: Save & Continue -->
  <div class="flex gap-4 mt-6" *ngIf="!isViewMode">
    <button class="btn-primary" (click)="submit()">{{ 'ONBOARDING.SAVE_AND_CONTINUE' | translate }}</button>
  </div>

  <!-- View mode: sirf Continue (bina save kiye) -->
  <div class="flex gap-4 mt-6" *ngIf="isViewMode">
    <button class="btn-primary" (click)="goToRiskFatca()">{{ 'COMMON.CONTINUE' | translate }}</button>
  </div>
</section>